"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("../../../preact-components/button-control"));

var SaveCustomViewModal = function SaveCustomViewModal(_ref) {
  var customViewName = _ref.customViewName,
      onDeleteCustomView = _ref.onDeleteCustomView,
      onClose = _ref.onClose,
      showModal = _ref.showModal;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: showModal,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Delete view \u2018".concat(customViewName, "\u2019?"),
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("p", null, "If you delete a view, it's gone for good.")), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
    title: "Delete",
    variant: "warning",
    onClick: onDeleteCustomView,
    class: "qa-delete-custom-view",
    newStyle: true,
    size: "medium"
  }), (0, _preact.h)(_buttonControl.default, {
    title: "Cancel",
    onClick: onClose,
    newStyle: true,
    size: "medium"
  })));
};

var _default = SaveCustomViewModal;
exports.default = _default;